import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import TOSModal from '../../components/auth/TOSModal';


const AppWrapper = ({ children }) => {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const refresh_tos = useSelector((state) => state.auth.currentUser.refresh_tos);

  return (
    <>
      <div className='app-wrapper' id='app-wrapper'>
        {children}
      </div>

      {/* Force accept TOS if refresh_tos is true */}
      {isLoggedIn && refresh_tos && <TOSModal />}
    </>
  );
};

AppWrapper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
  ]),
};

export default AppWrapper;
